import { render, staticRenderFns } from "./Tiendas.vue?vue&type=template&id=6bf2801e&scoped=true&"
import script from "./Tiendas.vue?vue&type=script&lang=js&"
export * from "./Tiendas.vue?vue&type=script&lang=js&"
import style0 from "./Tiendas.vue?vue&type=style&index=0&id=6bf2801e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf2801e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VAlert,VContainer,VSkeletonLoader})
